export enum ImageTypeEnum {
    AVATAR = 'user_avatars',
    POSTER = 'poster',
    TRANSLATION = 'translation',
    PROFILE_LOGO = 'profile_logos',
    CITY_ATTRACTION = 'city_attractions',
    CITY_ESTABLISHMENT = 'city_establishments',
    CITY_PERSON = 'city_people',
    CITY_READY_ROUTE = 'city_ready_routes',
    CITY_EXPERIENCE_REVIEW = 'city_experience_reviews',
}
